import { Reveal, Eyebrow } from "@/lib/motion";
import { TESTIMONIALS } from "@/data";

export default function Testimonials() {
  return (
    <section id="testimonials" data-testid="testimonials-section" className="bg-brand-peach my-16 md:my-24 py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <Eyebrow>Kind words</Eyebrow>
        <h2 className="mt-5 mb-14 md:mb-20 font-display font-normal text-4xl md:text-5xl lg:text-6xl tracking-tight max-w-3xl">
          Owners who got their time back.
        </h2>

        <div className="grid md:grid-cols-3 gap-8">
          {TESTIMONIALS.map((t, i) => (
            <Reveal key={t.name} delay={i * 0.12}>
              <figure className="h-full bg-brand-cream rounded-3xl border border-brand-apricot p-8 flex flex-col">
                <blockquote className="font-display text-xl md:text-2xl leading-snug flex-1">
                  “{t.quote}”
                </blockquote>
                <figcaption className="mt-8 flex items-center gap-4">
                  <img src={t.img} alt={t.name} className="w-12 h-12 rounded-full object-cover border border-brand-sage" />
                  <div>
                    <div className="font-medium">{t.name}</div>
                    <div className="font-mono text-xs uppercase tracking-[0.15em] text-brand-teal">{t.role}</div>
                  </div>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
